import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from 'store';

import FlightsSearch from 'components/FlightsSearch';
import { GetAllBillingCompanyResponse } from 'models/billingCompany';
import { FlightStretch } from 'models/flightSearch';
import { TravelArrangerUsersAllowed } from 'services/userService';

type Props = {
  allowedTravelers: TravelArrangerUsersAllowed[];
  isLoadingAllowedTravelers: boolean;
  branchCompanies?: GetAllBillingCompanyResponse[];
  isLoadingBranchCompanies: boolean;
};

const FlightsSearchContainer = ({
  allowedTravelers,
  isLoadingAllowedTravelers,
  branchCompanies,
  isLoadingBranchCompanies,
}: Props) => {
  const {
    travelers,
    departurePoint,
    arrivalPoint,
    departureDate,
    returnDate,
    baggageIncluded,
    directFlight,
    cabin,
    departureTime,
    returnTime,
    branchCompany,
    multiDestinationTrips,
    flightStretch,
  } = useSelector((state: RootState) => state.flights);

  return (
    <FlightsSearch
      defaultTravelers={travelers}
      defaultDeparturePoint={departurePoint}
      defaultArrivalPoint={arrivalPoint}
      defaultDepartureDate={departureDate}
      defaultReturnDate={returnDate}
      defaultDepartureTime={departureTime}
      defaultReturnTime={returnTime}
      defaultBaggageIncluded={baggageIncluded}
      defaultDirectFlight={directFlight}
      defaultCabin={cabin}
      allowedTravelers={allowedTravelers}
      isLoadingAllowedTravelers={isLoadingAllowedTravelers}
      branchCompanies={branchCompanies}
      isLoadingBranchCompanies={isLoadingBranchCompanies}
      defaultBranchCompany={branchCompany}
      defaultMultiDestinationTrips={multiDestinationTrips}
      defaultFlightStretch={flightStretch ?? FlightStretch.ROUND_TRIP}
    />
  );
};

export default FlightsSearchContainer;
